import React, { useEffect, useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { debounce } from "lodash";
import { Button } from "@/components/common/Button";
import { HiOutlineChevronDown } from "react-icons/hi";
import style from "./CTA.module.scss";
const CTAMobile = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  useEffect(() => {
    const handleScroll = debounce(() => {
      if (window.scrollY != 0) {
        setIsOpen(false);
      }
    }, 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const toggleOpen = () => setIsOpen(!isOpen);
  return <motion.div className={style.cta_mobile} animate={{
    bottom: isOpen ? 0 : "-85px",
    gap: isOpen ? "16px" : "32px",
    paddingTop: isOpen ? "24px" : "16px"
  }} data-sentry-element="unknown" data-sentry-component="CTAMobile" data-sentry-source-file="CTAMobile.tsx">
      <div className={style.cta_mobile__wrap} onClick={toggleOpen}>
        <p className={style.cta_text}>Get your Website QR Code easily!</p>

        <motion.div animate={{
        rotate: isOpen ? 0 : 180
      }} className={style.arrow} data-sentry-element="unknown" data-sentry-source-file="CTAMobile.tsx">
          <HiOutlineChevronDown color="#FFFFFF" size={24} data-sentry-element="HiOutlineChevronDown" data-sentry-source-file="CTAMobile.tsx" />
        </motion.div>
      </div>
      <Link href={"/"} data-sentry-element="Link" data-sentry-source-file="CTAMobile.tsx">
        <Button title={"Generate a QR Code"} variant="outline_primary" className={style.cta_mobile__btn} data-sentry-element="Button" data-sentry-source-file="CTAMobile.tsx" />
      </Link>
    </motion.div>;
};
export default CTAMobile;